import type { KhoaDich } from '../../i18n/types';
import type { Tang } from './chung/nghiep-vu/types';

/** Nhãn tầng ghi của một bước trong chuỗi xử lý (CLAUDE.md: "Bảng tông nằm ở `modules/<phân hệ>/constants.ts`"). */
export const NHAN_TANG: Record<Tang, KhoaDich> = {
  gateway: 'nktv.tang.gateway',
  nghiep_vu: 'nktv.tang.nghiep_vu',
};

/** Tên chuẩn của nhà cung cấp theo mã cổng AI ghi (`nhacungcap.NhanNhaCungCap`). Tên riêng nên không dịch. Mã lạ giữ nguyên. */
export const NHAN_NHA_CUNG_CAP: ReadonlyMap<string, string> = new Map([
  ['google', 'Google'],
  ['anthropic', 'Anthropic'],
  ['openai', 'OpenAI'],
  ['foxai', 'FoxAI'],
  ['whisper', 'Whisper'],
]);

/** Tên module theo mã trong `modules/<mã>/module.yaml`. Plugin của tenant không có ở đây thì giữ mã. */
export const NHAN_DICH_VU: ReadonlyMap<string, KhoaDich> = new Map<string, KhoaDich>([
  ['audit', 'nktvSuDungAi.dichVu.audit'],
  ['bien-ban', 'nktvSuDungAi.dichVu.bienBan'],
  ['bao-cao', 'nktvSuDungAi.dichVu.baoCao'],
  ['ekyc', 'nktvSuDungAi.dichVu.ekyc'],
  ['index', 'nktvSuDungAi.dichVu.index'],
  ['ocr', 'nktvSuDungAi.dichVu.ocr'],
  ['rpa', 'nktvSuDungAi.dichVu.rpa'],
  ['so-tay-viec', 'nktvSuDungAi.dichVu.soTayViec'],
  ['tham-dinh', 'nktvSuDungAi.dichVu.thamDinh'],
  ['tri-thuc', 'nktvSuDungAi.dichVu.triThuc'],
  ['tro-ly-ai', 'nktvSuDungAi.dichVu.troLyAi'],
  ['van-ban', 'nktvSuDungAi.dichVu.vanBan'],
]);

/**
 * Tên tính năng theo mã ở cột `tinh_nang` (`ma_tinh_nang`, không có thì `X-Ai-Feature`). Module ghi kèm nhãn tiếng Việt
 * nhưng không phải lượt nào cũng có, và nhãn ấy không đổi theo ngôn ngữ đang xem, nên mã có ở đây thì dùng bảng này.
 * Mã lạ dùng nhãn chụp trên bản ghi.
 */
export const NHAN_TINH_NANG_AI: ReadonlyMap<string, KhoaDich> = new Map<string, KhoaDich>([
  ['ocr_quet', 'nktvSuDungAi.tinhNang.ocrQuet'],
  ['ocr.nhan-dang', 'nktvSuDungAi.tinhNang.ocrQuet'],
  ['ocr_doc_trang', 'nktvSuDungAi.tinhNang.ocrDocTrang'],
  ['ocr.doc-trang', 'nktvSuDungAi.tinhNang.ocrDocTrang'],
  ['ocr_doc_truoc', 'nktvSuDungAi.tinhNang.ocrDocTruoc'],
  ['ocr.doc-truoc', 'nktvSuDungAi.tinhNang.ocrDocTruoc'],
  ['ocr_de_xuat_schema', 'nktvSuDungAi.tinhNang.ocrDeXuatSchema'],
  ['ocr.goi-y-cau-hinh', 'nktvSuDungAi.tinhNang.ocrDeXuatSchema'],
  ['tro_ly_sinh_sql', 'nktvSuDungAi.tinhNang.troLySinhSql'],
  ['tro_ly_soan_loi', 'nktvSuDungAi.tinhNang.troLySoanLoi'],
  ['tro_ly_doc_thanh_tieng', 'nktvSuDungAi.tinhNang.troLyDocThanhTieng'],
  ['tro_ly_tra_web', 'nktvSuDungAi.tinhNang.troLyTraWeb'],
  ['index.cau-truc', 'nktvSuDungAi.tinhNang.indexCauTruc'],
  ['index.doc-anh', 'nktvSuDungAi.tinhNang.indexDocAnh'],
  ['ekyc.boc-tach', 'nktvSuDungAi.tinhNang.ekycBocTach'],
  ['tham-dinh.hoi-dap', 'nktvSuDungAi.tinhNang.thamDinhHoiDap'],
  ['tham-dinh.danh-gia', 'nktvSuDungAi.tinhNang.thamDinhDanhGia'],
  ['tham-dinh.ban-sua', 'nktvSuDungAi.tinhNang.thamDinhBanSua'],
  ['tham-dinh.goi-y', 'nktvSuDungAi.tinhNang.thamDinhGoiY'],
  ['tham-dinh.cham', 'nktvSuDungAi.tinhNang.thamDinhCham'],
  ['tham-dinh.can-trong-so', 'nktvSuDungAi.tinhNang.thamDinhCanTrongSo'],
  ['bien-ban.nhan-dang', 'nktvSuDungAi.tinhNang.bienBanNhanDang'],
  ['bien-ban.tom-tat', 'nktvSuDungAi.tinhNang.bienBanTomTat'],
  ['van-ban.tom-tat', 'nktvSuDungAi.tinhNang.vanBanTomTat'],
  ['van-ban.soan-thao', 'nktvSuDungAi.tinhNang.vanBanSoanThao'],
  ['van-ban.dien-truong', 'nktvSuDungAi.tinhNang.vanBanDienTruong'],
  ['van-ban.phan-cong', 'nktvSuDungAi.tinhNang.vanBanPhanCong'],
  ['van-ban.phan-ra', 'nktvSuDungAi.tinhNang.vanBanPhanRa'],
  ['van-ban.doc-pdf-quet', 'nktvSuDungAi.tinhNang.vanBanDocPdfQuet'],
  ['van-ban.xem-truoc-mau', 'nktvSuDungAi.tinhNang.vanBanXemTruocMau'],
]);
